import WebNewsPage from "../../pages/legacy/webNews/WebNewsPage";

const route = {
  key: "webNews",
  path: "/legacy/web-news",
  component: WebNewsPage,
  private: true,
  layout: "main",
  icon: "faNewspaper",
  group: "cms",
  order: 10,
  permission: "legacy.webNews.read"
};

export default route;